import axiosInstance from "../../../config/axios-config"

// TODO :: Remember urlSearchParams is an plain object or URLSearchParams Object
async function getProjects(url, jwtToken, urlSearchParams, setProjects) {
    try {
        const response = await axiosInstance.get(url, {
            headers: {
                Authorization: `Bearer ${jwtToken}`,
            },
            params: urlSearchParams
        });

        const projects = await response.data;

        console.log(projects);

        setProjects(projects);
    } catch(err) {
        console.log(err);
    }   
}

export { getProjects };

